import { useTranslation } from 'react-i18next'
import './PageLoader.css'

interface Props {
  label?: string
}

export function PageLoader({ label }: Props) {
  const { t } = useTranslation()
  return (
    <div className="page-loader">
      <div className="page-loader__dot" />
      <span className="page-loader__label">{label ?? t(($) => $.common.loading)}</span>
    </div>
  )
}
